module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_fondo_15.3dd01a36.png";